/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Cta_DownloadInputs */

const en_wc_cta_download = /** @type {(inputs: Wc_Cta_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download WordCraft`)
};

/**
* | output |
* | --- |
* | "Download WordCraft" |
*
* @param {Wc_Cta_DownloadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_cta_download = /** @type {((inputs?: Wc_Cta_DownloadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Cta_DownloadInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_cta_download(inputs)
});
export { wc_cta_download as "wc.cta.download" }